(function () {
    window.User ={}
    var unsafeData = window.Telegram.WebApp.initDataUnsafe;
    var telegramUser = unsafeData.user;
    window.User.first_name = telegramUser !=undefined ? telegramUser.first_name : "";
    window.User.last_name = telegramUser !=undefined ?telegramUser.last_name : "";
    window.User.chatID = telegramUser !=undefined ?telegramUser.id : "";
    window.User.bot_name = telegramUser !=undefined ?telegramUser.bot_name : "";
    window.User.phone_number = telegramUser !=undefined ? telegramUser.phone_number : "";

    let startParam = window.Telegram.WebApp.initDataUnsafe.start_param

	 console.log("telegramUser",window.User.phone_number)
     console.log("telegramUser",startParam)
})()